import { render, staticRenderFns } from "./CACG1070.vue?vue&type=template&id=853e5a62"
import script from "./CACG1070Controller.ts?vue&type=script&lang=ts&external"
export * from "./CACG1070Controller.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports